import { Navigate, Outlet } from 'react-router-dom';

const UserAuthRoute = () => {
  const token = localStorage.getItem('slm-token');
  return token ? <Navigate to='/images' /> : <Outlet />;
};

export default UserAuthRoute;
